export default [
  {
    category: 'Team Collaboration',
    features: [
      'asset_library',
      'collaboration',
      'group_templates',
      'library_read',
      'lite_library',
      'shared_library',
      'add_users',
      // 'advanced_permissions',
      'build_surveys_together',
      'analyze_results_together',
      'custom_templates',
      'team_themes',
      'shared_group_library',
    ],
  },
  {
    category: 'Team Management',
    features: [
      'team_ownership',
      // 'add_additional_users',
      // 'contributor_seats_analyst',
      'consolidated_billing',
      'user_management',
      'data_ownership',
    ],
  },
  {
    category: 'Enterprise-grade admin and security',
    features: [
      'hipaa_enabled',
      'admin_dashboard',
      'single_sign_on',
      // 'enterprise_activity_tracking',
      // 'enterprise_account_control',
      // 'enterprise_sso',
      // 'enterprise_global_settings',
      // 'enterprise_custom_terms_of_service',
      // 'enterprise_integrations',
      // 'enterprise_hipaa_compliance',
    ],
  },
  {
    category: 'Survey Capabilities',
    features: [
      'base_response_count',
      // 'create_survey_limit',
      'create_question_limit',
      'analyze_response_limit',
      // 'website_collectors_enabled',
      'collector_create_limit',
      'email_tracking_enabled',
      'pop_up_collector',
      'track_email_responses',
      // 'mobile_apps_ios_android',
      'recurring_surveys',
      // 'payment_question_type',
      // 'inactivity_timer',
      // 'passcode_lock',
      'max_collectors_per_survey',
      'matrix_question_type',
      'menu_matrix_enabled',
      'num_free_responses',
      'payment_qt',
      'survey_create_limit',
      'recurring_email_collector_enabled',
      'collector_offline_kiosk_enabled',
      'collector_popup_enabled',
      'kiosk_mode_inactivity_timer',
      'kiosk_mode_passcode_lock',
    ],
  },
  {
    category: 'Fast Support',
    features: [
      'email_support',
      // 'expedited_email_support',
      'phone_support',
      // 'phone_support_non_en',
      // 'team_customer_success_manager',
      'priority_email_support',
    ],
  },
  {
    category: 'Survey Builder',
    features: [
      'click_map_qt',
      'essential_question_types',
      'all_languages_supported',
      'pagination',
      'labeling_titles_numbering',
      'create_templates_enabled',
      // 'create_templates_enabled_non_en',
      'question_library',
      // 'question_library_non_en',
      '508_accessibility',
      'ranking_question_type',
      'slider_question_type',
      'collect_contact_information',
      // 'video_and_image_question_type',
      'rating_question_type',
      // 'quiz_scoring_and_instant_results',
      'quizzes_pro',
      // 'matrix_of_dropdown_menus',
      'file_upload',
      // 'create_randomization_enabled',
      'a_b_testing',
      'create_quotas_enabled',
      // 'summary_click_map_question_type',
      'multilingual',
      'advanced_logic',
      'multiple_block_rotation_enabled',
      // 'custom_question_bank',
      'extended_piping',
      'star_rating_question_type',
      'video_question_type',
      'survey_templates_intl',
      'question_library_intl',
    ],
  },
  {
    category: 'Customization & Branding',
    features: [
      'analyze_can_share_customize_branding',
      'analyze_can_share_customize_domain',
      'progress_bar',
      'text_formatting',
      'create_logo_enabled',
      'create_custom_theme_enabled',
      'premium_themes',
      'collector_friendly_url_enabled',
      'collector_thank_you_enabled',
      'customize_disqualification_page_enabled',
      // 'custom_html_email_invitations',
      'create_grayscale_footer',
      'create_piping_enabled',
      'carry_forward',
      'create_custom_variables_enabled',
      'create_toggle_footer_enabled',
      'collector_completion_url_enabled',
      'collector_white_label_enabled',
      'create_custom_html_email_message_enabled',
      'create_skip_logic_enabled',
      // 'custom_subdomain',
      'new_stock_themes',
      'hide_export_branding_enabled',
    ],
  },
  {
    category: 'Analysis & Reporting',
    features: [
      'analyze_can_customize_charts',
      'analyze_combine_filters',
      'analyze_dashboard_password_enabled',
      'analyze_export_enabled',
      'analyze_sentiment_enabled',
      'real_time_results',
      // 'analyze_shared_results_enabled',
      'benchmarks',
      // 'industry_benchmarks',
      'analyze_trends_enabled',
      // 'response_quality',
      'filter_crosstab',
      // 'word_cloud',
      // 'text_analysis',
      // 'dashboard',
      // 'dashboard_password_protection',
      'statistical_significance',
      'custom_charts',
      'create_print_enabled',
      'download_as_csv_xls_pdf',
      'download_as_ppt',
      'analyze_export_spss_enabled',
      // 'word_cloud_combine_hide',
      // 'sentiment_analysis',
      // 'crosstab',
      'plans_benchmarks',
      'response_quality_enabled',
      'show_create_crosstab',
      'show_sig_diffs_enabled',
      'analyze_rule_based_tagging',
      'analyze_access_benchmarking',
      'share_surveys',
    ],
  },
  {
    category: 'Response Management',
    features: [
      'respondent_receipt',
      'require_answer',
      'validate_answer',
      'randomize_answer_choices',
      'set_survey_end_date',
      'view_respondent_ip_address',
      'record_respondent_email_address',
      // 'confirmation_email_to_respondents',
      // 'set_max_response_count',
    ],
  },
  {
    category: 'Enhanced Security',
    features: ['password_protection', 'enable_ip_blocking'],
  },
  {
    category: 'Partner Integrations & APIs',
    features: [
      'collector_mobile_sdk_enabled',
      'mobile_sdk_pull_response_data_enabled',
      // 'send_surveys',
      // 'mobile_sdk',
      // 'mobile_sdk_data_pull',
      'extract_data',
      // 'api_access',
      'private_apps',
      'analyze_integrations',
    ],
  },
];
